import { render, staticRenderFns } from "./ops-settings.vue?vue&type=template&id=fa865668&scoped=true&"
import script from "./ops-settings.vue?vue&type=script&lang=ts&"
export * from "./ops-settings.vue?vue&type=script&lang=ts&"
import style0 from "./ops-settings.vue?vue&type=style&index=0&id=fa865668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa865668",
  null
  
)

export default component.exports